export default function(y) {
	return y < 1000 ? y + 1900 : y;
}
